import cls from 'classnames';
import useFormat from '../../hooks/useFormat';
import usePrice from '../../hooks/usePrice';

const CartPrice = ({ product_variation, quantity }) => {
    const { formatPrice }  = useFormat();
    const { productPrice } = usePrice({
        variation : product_variation,
        product   : product_variation.product,
        quantity  : quantity,
    });
    const { price, salePrice } = productPrice;

    return(
        <>
            {Boolean(salePrice) && (
                <div className="flex flex-shrink-0 flex-grow-0 items-center">
                    <div className='font-bold'>
                        {formatPrice(salePrice)}
                    </div>
                </div>
            )}
            <div className="flex flex-shrink-0 flex-grow-0 items-center">
                <div
                    className={cls({
                        'text-dark': !salePrice,
                        'text-grey line-through': salePrice,
                    })}
                >
                    {formatPrice(price)}
                </div>
            </div>
        </>
    );
};

export default CartPrice;
